import { observer } from "mobx-react-lite";
import { useContext, useEffect,useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { translationHookOptions } from "../app/localization/localization";
import { RootStoreContext } from "../app/stores/rootStore";
import InfoMessage from "../components/common/InfoMessage";
import { RouteComponentProps } from "react-router";
import LogOutSSO from "../views/LogOutSSO";

interface DetailParams {
  isInactive?: string;
}

const ExpiredLayout : React.FC<RouteComponentProps<DetailParams>>= ({match}) => {
  const rootStore = useContext(RootStoreContext);
  const { logout,user } = rootStore.userStore;
  const [t] = useTranslation(["toast", "translation"], translationHookOptions);
  const [isSSOLogout, setisSSOLogout] = useState(false);
  useEffect(() => {
    console.log("expired")
    let isInactive = match.params.isInactive;
    if (isInactive) {
    toast.info('Utente inattivo, fai di nuovo login', {
      toastId: 'Expired',
      autoClose: 1000, // Durata in millisecondi 
      onClose: () => {
        if (user && user.logoutUrl){
          setisSSOLogout(true);
        }else {
            logout();
        }
      }
    });
  } else {
    toast.info(t("expired_session"), {
      toastId: 'Expired',
      autoClose: 1000, // Durata in millisecondi 
      onClose: () => {
        if (user && user.logoutUrl){
          setisSSOLogout(true);
        }else {
            logout();
            
        }
      }
    });
  }

  }, [logout, match.params.isInactive, t]);

  return (
    <>
    { isSSOLogout ? (
    <>
      <LogOutSSO />
    </>
    ):(
    <div>
      <InfoMessage icon="fas fa-clock fa-3x" message={t("expired_session_message", { ns : "translation"})} />
    </div>
     )}
     </>
  );
};

export default observer(ExpiredLayout);
